<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div style="display: flex; justify-content: flex-end">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="printAllButtonLoading"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>cloud_download</v-icon>Export
              </v-btn>
            </template>
            <v-list>
              <v-list-tile
                @click="printAllPurchaseOrder('printAllPurchaseOrder')"
              >
                <v-list-tile-content>
                  <v-list-tile-title>PRINT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="exportAllPurchaseOrder()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{
              showFilters ? "arrow_drop_up" : "arrow_drop_down"
            }}</v-icon>
            <v-icon></v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.fromIssueDate"
                  label="From Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.fromIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-menu
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="queryParams.toIssueDate"
                  label="To Date"
                  prepend-icon="event"
                  readonly
                ></v-text-field>
                <v-date-picker
                  v-model="queryParams.toIssueDate"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="issueNo"
                label="Issue No"
                type="text"
                v-model="queryParams.issueNo"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="purchaseOrderStatusList"
                label="Choose Status ..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.status"
              ></v-select>
            </v-flex>
            <v-flex
              sm3
              v-if="
                user.roleName == 'ADMIN' || user.roleName == 'FINANCE_MANAGER'
              "
            >
              <v-autocomplete
                :items="warehouseList"
                :hide-no-data="true"
                color="blue-grey lighten-2"
                label="Choose Warehouse..."
                item-value="id"
                item-text="name"
                menu-props="auto"
                v-model="queryParams.warehouseId"
              ></v-autocomplete>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="purchaseTypeList"
                label="Choose Purchase Type..."
                :hide-no-data="true"
                color="blue-grey lighten-2"
                item-text="label"
                item-value="value"
                menu-props="auto"
                v-model="queryParams.purchaseType"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="description"
                label="Description"
                type="text"
                v-model="queryParams.description"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title class="blue darken-3">
            <span class="headline white--text">Summary</span>
            <v-spacer></v-spacer>
            <v-icon @click="show = !show" class="white--text">{{
              show ? "keyboard_arrow_up" : "keyboard_arrow_down"
            }}</v-icon>
          </v-card-title>
          <v-card-text class="font-weight-bold" v-show="show">
            <div>
              <span>Total Amount:</span>
              <v-chip>
                <span>{{ totalAmount | decFormat(6) }}</span>
              </v-chip>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="purchaseOrderList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.status }}</td>
              <td>
                {{ props.item.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td>{{ props.item.issueNo }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.purchaseType }}</td>
              <td style="text-align: right">
                {{ props.item.totalUnitCost | decFormat(6) }}
              </td>
              <td style="text-align: right">
                {{ props.item.creditPaidAmount | decFormat(6) }}
              </td>
              <td>
                {{ props.item.estArrivalDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.description }}</td>
              <td>
                {{
                  props.item.updatedDateInMilliSeconds
                    | format-ms-date-time
                }}
              </td>
              <td>{{ props.item.updatedBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <!--print all-->
    <div
      id="printAllPurchaseOrder"
      style="border: 1px solid black; width: 300px"
      v-show="false"
    >
      <div style="text-align: center">
        <p style="font-size: 18px; margin: 1px">Purchase Order Report</p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 15px; margin: 1px">
          From Date: [{{ this.queryParams.fromIssueDate | formatDate }}] To
          Date: [{{ this.queryParams.toIssueDate | formatDate }}]
        </p>
      </div>
      <div style="text-align: center">
        <p style="font-size: 14px; margin: 1px">
          Reported Date: [{{ reportedDate }}]
        </p>
      </div>
      <br />
      <div style="padding-left: 5px; padding-right: 5px">
        <table
          style="
            font-family: arial, sans-serif;
            border-collapse: collapse;
            width: 100%;
            font-size: 12px;
            border-top: 1px solid black;
          "
        >
          <thead
            style="border-bottom: 1px solid black; border-top: 1px solid black"
          >
            <tr>
              <th style="border: 1px solid black; text-align: center">
                Invoice No
              </th>
              <th style="border: 1px solid black; text-align: center">
                Received Date
              </th>
              <th style="border: 1px solid black; text-align: center">
                Purchase Type
              </th>
              <th style="border: 1px solid black; text-align: center">
                Location
              </th>
              <th style="border: 1px solid black; text-align: center">
                Product Name
              </th>
              <th style="border: 1px solid black; text-align: center">Unit</th>
              <th style="border: 1px solid black; text-align: center">Cur</th>
              <th style="border: 1px solid black; text-align: center">Price</th>
              <th style="border: 1px solid black; text-align: center">Qty</th>
              <th style="border: 1px solid black; text-align: center">
                Amount
              </th>
            </tr>
          </thead>
          <tbody v-for="(header, index) in allPurchaseOrderList" :key="index">
            <tr
              style="height: 30px"
              v-for="(item, i) in header.purchaseOrderItems"
              :key="i"
            >
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.issueNo }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.issueDateInMilliSeconds | format-ms-date }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.purchaseType }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-if="i == 0"
              >
                {{ header.warehouseName }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td style="border: 1px solid black; text-align: left">
                {{ item.productName }}
              </td>
              <td
                style="border: 1px solid black; text-align: left"
                v-if="item.isItemDiscount == 1"
              >
                {{ item.factorUnitName + " (" + item.discountPercent + "%) " }}
              </td>
              <td style="border: 1px solid black; text-align: left" v-else>
                {{ item.unitName }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: center"
                v-if="i == 0"
              >
                {{ header.currencyCode }}
              </td>
              <td
                style="border-left: 1px solid black; text-align: left"
                v-else
              ></td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.unitCost | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ item.qty | decFormat(6) }}
              </td>
              <td style="border: 1px solid black; text-align: right">
                {{ (item.qty * item.unitCost) | decFormat(6) }}
              </td>
            </tr>
            <tr>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
                colspan="8"
              >
                Sub Total
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalQty }}
              </td>
              <td
                style="
                  border: 1px solid black;
                  font-weight: bold;
                  text-align: right;
                "
              >
                {{ header.totalUnitCost | decFormat(6) }}
              </td>
            </tr>
          </tbody>
          <tr>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
              colspan="8"
            >
              Grand Total
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ allTotalQty | decFormat(6) }}
            </td>
            <td
              style="
                border: 1px solid black;
                font-weight: bold;
                text-align: right;
              "
            >
              {{ totalAmount | decFormat(6) }}
            </td>
          </tr>
        </table>
      </div>
    </div>
  </v-container>
</template>

<script>
import { purchaseOrderService } from "../../services/purchase-order-service";
import { warehouseService } from "../../services/warehouse-service";
import { commonService } from "../../services/common-service";

export default {
  name: "PurchaseOrderList",

  components: {},
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    showFilters: false,
    show: false,
    issueDate: commonService.formatDate(
      new Date().toISOString().substr(0, 10),
      "YYYY-MM-DD"
    ),
    showListLoading: false,
    breadcrumbs: [
      {
        text: "Reports",
        disabled: true,
      },
      {
        text: "Purchase Reports",
        disabled: true,
      },
      {
        text: "Purchase Order Report",
        disabled: true,
      },
    ],
    headers: [
      { text: "Status", value: "status" },
      { text: "Issue Date", align: "left", value: "issueDate" },
      { text: "Issue No", value: "issueNo" },
      { text: "Warehouse", value: "warehouse.name" },
      { text: "Purchase Type", value: "purchaseType" },
      { text: "Total Net Amount", value: "totalAmount", sortable: false },
      { text: "Credit Paid Amount", sortable: false },
      { text: "Est. Arrival Date", value: "estArrivalDate" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    purchaseOrderStatusList: [{ label: "----All----", value: "" }],
    purchaseTypeList: [{ label: "---All---", value: "" }],
    purchaseOrderList: [],
    warehouseList: [],
    totalRows: 0,
    totalAmount: 0,
    allTotalQty: 0,
    allPurchaseOrderList: [],
    printAllButtonLoading: false,
    reportedDate: commonService.formatDate(new Date(), "DD/MM/YYYY"),
    queryParams: {
      fromIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toIssueDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      status: "",
      warehouseId: "",
      description: "",
      updateUserId: "",
      purchaseType: "",
    },
  }),
  watch: {
    pagination: {
      handler() {
        this.getPurchaseOrderList();
      },
      deep: true,
    },
  },
  created() {
    if (this.user.role.roleName == "BRANCH_ADMIN") {
      this.queryParams.warehouseId = this.user.warehouseId;
    }
    if (this.$route.query.fromIssueDate) {
      this.queryParams.fromIssueDate = this.$route.query.fromIssueDate;
    }
    if (this.$route.query.toIssueDate) {
      this.queryParams.toIssueDate = this.$route.query.toIssueDate;
    }
    if (this.$route.query.issueNo) {
      this.queryParams.issueNo = this.$route.query.issueNo;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.updateUserId) {
      this.queryParams.updateUserId = this.$route.query.updateUserId;
    }
    if (this.$route.query.purchaseType) {
      this.queryParams.purchaseType = this.$route.query.purchaseType;
    }
    if (this.$route.query.warehouseId) {
      this.queryParams.warehouseId = this.$route.query.warehouseId;
    }
    if (this.$route.query.description) {
      this.queryParams.description = this.$route.query.description;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.rowsPerPage) {
      this.pagination.rowsPerPage = this.$route.query.rowsPerPage;
    }
    this.decimalFormat = commonService.format4DecimalPlace();
    this.getAllPOStatus();
    this.getWarehouseList();
    this.getAllPurchaseType();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.rowsPerPage = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "purchase-order-report",
        query: this.queryParams,
      });
      this.getPurchaseOrderList();
    },
    getPurchaseOrderList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      purchaseOrderService
        .getPurchaseOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.purchaseOrderList = res.data.data;
            this.totalRows = res.data.totalElements;
            this.totalAmount = res.data.totalAmount;
            this.allTotalQty = res.data.allTotalQty;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getWarehouseList() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
          let findAll = {
            id: "",
            name: "----All----",
          };
          this.warehouseList.splice(0, 0, JSON.parse(JSON.stringify(findAll)));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    printAllPurchaseOrder(divName) {
      this.printAllButtonLoading = true;
      purchaseOrderService
        .getAllPurchaseOrderList(this.queryParams)
        .then((res) => {
          if (res.data) {
            this.allPurchaseOrderList = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          var printContents = document.getElementById(divName).innerHTML;
          var reprintWindow = window.open(
            "",
            "MsgWindow",
            "width=500,height=500"
          );
          reprintWindow.document.write(printContents);
          setTimeout(() => {
            reprintWindow.print();
            reprintWindow.close();
          }, 600);
          this.printAllButtonLoading = false;
        });
    },
    exportAllPurchaseOrder() {
      this.printAllButtonLoading = false;
      purchaseOrderService
        .exportPurchaseOrderExcel(this.queryParams)
        .then((res) => {
          commonService.downloadE(res);
        })
        .catch((err) => {
          console.log(err);
        });
      this.printAllButtonLoading = false;
    },
    getAllPOStatus() {
      purchaseOrderService.getAllPurchaseOrderStatus().then((res) => {
        let tempList = res.data;
        tempList.forEach((temp) => {
          let tempObj = { label: temp, value: temp };
          this.purchaseOrderStatusList.push(tempObj);
        });
      });
    },
    getAllPurchaseType() {
      purchaseOrderService.getAllPurchaseType().then((res) => {
        let tempList = res.data;
        tempList.forEach((item) => {
          let tempObj = { label: item, value: item };
          this.purchaseTypeList.push(tempObj);
        });
      });
    },
  },
};
</script>